// extracted by mini-css-extract-plugin
export default {"Instructions":"styles_Instructions__vNavi","header":"styles_header__pj0WE","explanation":"styles_explanation__+DK-Q","bolded":"styles_bolded__CPklR"};